export interface RuntimeState {
  getRuntimeState: () => StateParameters;
  setParameters: (params?: Partial<StateParameters>) => void;
}

interface StateParameters {
  [key: string]: unknown;
  isStorageInitialized?: boolean;
}

let runtimeState: RuntimeState | undefined;

export const createRuntimeState = (): RuntimeState => {
  if (runtimeState) {
    return runtimeState;
  }

  let currentState: StateParameters = {};

  const setParameters: (configParams: Partial<StateParameters>) => void = (
    configParams: Partial<StateParameters>
  ) => {
    currentState = { ...currentState, ...configParams };
  };

  const getRuntimeState = () => currentState;

  runtimeState = {
    setParameters,
    getRuntimeState,
  };

  return runtimeState;
};

/**
 * For testing purposes only, to reset the singleton state between tests. Should not be used in production code.
 */
export const resetRuntimeState = () => {
  runtimeState = undefined;
};
